/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * One glyph per settings section, for the surfaces that show them as rows.
 *
 * The five sections that correspond to a navigation module — Imóveis,
 * Vendas, Locações, Portais, Facebook e Instagram — deliberately borrow that
 * module's own icon from `agency-nav.items`, so the row that configures
 * Locações wears the same key the rail does. An icon chosen twice is an
 * icon that eventually disagrees with itself.
 */

import {
  HomeIcon, PersonIcon, LockClosedIcon, IdCardIcon, GlobeIcon, InstagramLogoIcon,
} from '@/shared/ui/radix-icons';
import { CircleDollarSign, KeyRound } from 'lucide-react';
import { TagIcon } from '@/shared/ui/components/basic/icons';
import type { SettingsSection } from './settings-nav';

type IconComponent = React.ComponentType<{ width?: number; height?: number }>;

export const SETTINGS_SECTION_ICONS: Record<SettingsSection, IconComponent> = {
  perfil: HomeIcon,
  equipe: PersonIcon,
  permissoes: LockClosedIcon,
  plano: IdCardIcon,
  portais: GlobeIcon,
  facebook: InstagramLogoIcon,
  vendas: CircleDollarSign,
  locacoes: KeyRound,
  imoveis: TagIcon,
};
